<template>
  <div class="l-container confirm-info mx-auto">
    <div class="top-title ml-2">
      <h3>ロープライス・ギャランティー申請内容確認</h3>
    </div>
    <div class="mt-6 mb-6 divider"></div>
    <div class="main-content mb-4">
      <div class="c-box p-8">
        <Item :data="dataItemOrder" />
        <div>
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[0]"
          />
          <div class="box-content">
            <div class="style-div">
              <span class="title font-bold">宿泊期間</span>
              <span class="results"><span v-if="useDate" class="text-black">{{useDate}}</span> <span  class="text-black" v-if="nightCnt">{{nightCnt}}泊</span> <span  class="text-black" v-if="roomCnt">{{roomCnt}}部屋</span> (大人{{totalAdult}}名/子ども{{totalChild}}名) </span>
            </div>
            <div class="style-div">
              <span class="title font-bold">チェックイン</span>
              <span class="results" v-if="checkOutTm">{{checkOutTm}}</span>
            </div>
            <div class="style-div">
              <span class="title font-bold">部屋タイプ</span>
              <span class="results">{{typeOfRoom}}</span>
            </div>
          </div>

          <div v-for="(item, index) in stayRoomDayPrtic" :key="`room-${index}`"> 
            <span class="title font-bold">{{index+1}}部屋目</span> 
            <div>
              <div class="flex mt-4" v-if="item.adultTotalHeadCnt + item.chldHeadCnt> 0">
                <div class="w-1/6">
                  <span class="title">会員</span> 
                </div>
                <div class="w-5/6">

                  <div class="flex justify-between" v-if="item.adultManHeadCnt">
                    <div class="item">
                      <span class="results mr-2">大人男性</span>
                      <span class="results">{{item.adultManHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">大人男性 {{item.adultMemberChrg ? item.adultMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.adultManHeadCnt}}名 = {{item.adultMemberChrg ? item.adultMemberChrg : item.roomMemberChrg * item.adultManHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>

                  <div class="flex justify-between" v-if="item.adultWomanHeadCnt">
                    <div class="item">
                      <span class="results mr-2">大人女性</span>
                      <span class="results">{{item.adultWomanHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">大人女性 {{item.adultMemberChrg ? item.adultMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.adultWomanHeadCnt}}名 = {{item.adultMemberChrg ? item.adultMemberChrg : item.roomMemberChrg * item.adultWomanHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>

                  <div class="flex justify-between" v-if="item.chldaHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 高学年</span>
                      <span class="results">{{item.chldaHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 高学年 {{item.chldaMemberChrg ? item.chldaMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldaHeadCnt}}名 = {{item.chldaMemberChrg ? item.chldaMemberChrg : item.roomMemberChrg * item.chldaHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.chldbHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 低学年</span>
                      <span class="results">{{item.chldbHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 低学年 {{item.chldbMemberChrg ? item.chldbMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldbHeadCnt}}名 = {{item.chldbMemberChrg ? item.chldaMemberChrg : item.roomMemberChrg * item.chldbHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.chldcHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 食事・布団付</span>
                      <span class="results">{{item.chldcHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 食事・布団付 {{item.chldcMemberChrg ? item.chldcMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldcHeadCnt}}名 = {{item.chldcMemberChrg ? item.chldcMemberChrg : item.roomMemberChrg * item.chldcHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.chlddHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 食事のみ</span>
                      <span class="results">{{item.chlddHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 食事のみ {{item.chlddMemberChrg ? item.chlddMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chlddHeadCnt}}名 = {{item.chlddMemberChrg ? item.chlddMemberChrg : item.roomMemberChrg * item.chlddHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.chldeHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 布団のみ</span>
                      <span class="results">{{item.chldeHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 布団のみ {{item.chldeMemberChrg ? item.chldeMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldeHeadCnt}}名 = {{item.chldeMemberChrg ? item.chldeMemberChrg : item.roomMemberChrg * item.chldeHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.chldfHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 食事・布団不要</span>
                      <span class="results">{{item.chldfHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 食事・布団不要 {{item.chldfMemberChrg ? item.chldfMemberChrg : item.roomMemberChrg | formatCurrency}} x {{item.chldfHeadCnt}}名 = {{item.chldfMemberChrg ? item.chldfMemberChrg : item.roomMemberChrg * item.chldfHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>

                </div>
              </div>

              <div class="flex mt-4" v-if="item.vistrAdultTotalHeadCnt + item.vistrChldHeadCnt > 0">
                <div class="w-1/6">
                  <span class="title">ビジター</span> 
                </div>
                <div class="w-5/6">

                  <div class="flex justify-between" v-if="item.vistrAdultManHeadCnt">
                    <div class="item">
                      <span class="results mr-2">大人男性</span>
                      <span class="results">{{item.vistrAdultManHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">大人男性 {{getVisitorPrice(item.adultMemberChrg, item.adultBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.vistrAdultManHeadCnt}}名 = {{(getVisitorPrice(item.adultMemberChrg, item.adultBoneSbsidChrg, item.roomMemberChrg)) * item.vistrAdultManHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>

                  <div class="flex justify-between" v-if="item.vistrAdultWomanHeadCnt">
                    <div class="item">
                      <span class="results mr-2">大人女性</span>
                      <span class="results">{{item.vistrAdultWomanHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">大人女性 {{getVisitorPrice(item.adultMemberChrg, item.adultBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.vistrAdultWomanHeadCnt}}名 = {{(getVisitorPrice(item.adultMemberChrg, item.adultBoneSbsidChrg, item.roomMemberChrg)) * item.vistrAdultWomanHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>

                  <div class="flex justify-between" v-if="item.vistrChldaHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 高学年</span>
                      <span class="results">{{item.vistrChldaHeadCnt}}名</span>
                    </div>
                    <div>
                      
                      <span class="text-right">子ども 高学年 {{getVisitorPrice(item.chldaMemberChrg, item.chldaBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldaHeadCnt}}名 = {{ (getVisitorPrice(item.chldaMemberChrg, item.chldaBoneSbsidChrg, item.roomMemberChrg)) * item.chldaHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.vistrChldbHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 低学年</span>
                      <span class="results">{{item.vistrChldbHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 低学年 {{getVisitorPrice(item.chldbMemberChrg, item.chldbBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldbHeadCnt}}名 = {{(getVisitorPrice(item.chldbMemberChrg, item.chldbBoneSbsidChrg, item.roomMemberChrg)) * item.chldbHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.vistrChldcHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 食事・布団付</span>
                      <span class="results">{{item.vistrChldcHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 食事・布団付 {{getVisitorPrice(item.chldcMemberChrg, item.chldcBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldcHeadCnt}}名 = {{(getVisitorPrice(item.chldcMemberChrg, item.chldcBoneSbsidChrg, item.roomMemberChrg)) * item.chldcHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.vistrChlddHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 食事のみ</span>
                      <span class="results">{{item.vistrChlddHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 食事のみ {{getVisitorPrice(item.chlddMemberChrg, item.chlddBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chlddHeadCnt}}名 = {{(getVisitorPrice(item.chlddMemberChrg, item.chlddBoneSbsidChrg, item.roomMemberChrg)) * item.chlddHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.vistrChldeHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 布団のみ</span>
                      <span class="results">{{item.vistrChldeHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 布団のみ {{getVisitorPrice(item.chldeMemberChrg, item.chldeBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldeHeadCnt}}名 = {{(getVisitorPrice(item.chldeMemberChrg, item.chldeBoneSbsidChrg, item.roomMemberChrg)) * item.chldeHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                  <div class="flex justify-between" v-if="item.vistrChldfHeadCnt">
                    <div class="item">
                      <span class="results mr-2">子ども 食事・布団不要</span>
                      <span class="results">{{item.vistrChldfHeadCnt}}名</span>
                    </div>
                    <div>
                      <span class="text-right">子ども 食事・布団不要 {{getVisitorPrice(item.chldfMemberChrg, item.chldfBoneSbsidChrg, item.roomMemberChrg) | formatCurrency}} x {{item.chldfHeadCnt}}名 = {{(getVisitorPrice(item.chldfMemberChrg, item.chldfBoneSbsidChrg, item.roomMemberChrg)) * item.chldfHeadCnt | formatCurrency}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>  
        <div class="flex mt-4 justify-end ">
          <span class="mr-4 font-bold self-center" style="font-size:16px">
            宿泊料合計
          </span>
          <span class="font-bold" style="font-size:24px">{{ totalAmount | formatInteger }}円</span>
        </div>
        <div class="mt-8 mb-12 divider"></div>
        <SectionContentTitle
          :lineType="lineType.vertical"
          :titleContent="titleContent[1]"
        />
        <table class="table-common1">
          <Label
            v-for="(i, index) in dataWebRegister"
            :key="`item-dataWebRegister-${index}`"
            :title="i.title"
            :category="i.category"
            :data="i.data"
          />
          <div class="hide-div divider"></div>
        </table>
        <div class="mt-16 mb-12 divider"></div>
        <div class="flex gap-2 justify-center mt-4 mb-4">
          <button @click="handleBack" class="c-btn btn-white">
            <span class="">戻る</span>
          </button>
          <button @click="gotoComplete" class="c-btn btn-grey">
            <span class="">申請する</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Item, SectionContentTitle } from '@/components/compound'

import Label from './components/Input'
import _ from 'lodash'

export default {
  name: 'BS_APP_03_002',
  components: {
    SectionContentTitle,
    Label,
    Item
  },
  data() {
    return {
      dataItemOrder: null,
      orderDetail: null,
      contentRegister: null,
      titleContent: ['お申し込み内容', '申請内容'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      useDate: null,
      roomCnt: null,
      nightCnt: null,
      checkOutTm: null,
      typeOfRoom: null,
      stayRoomDayPrtic: null,
      totalAmount: null,
      totalAdult: 0,
      totalChild: 0,
      dataWebRegister: [
        {
          title: 'サイト名',
          category: '必須',
          data: ''
        },
        {
          title: 'プラン名',
          category: '必須',
          data: '◯◯◯◯◯◯◯◯プラン'
        },
        {
          title: '部屋タイプ',
          category: '必須',
          data: '◯◯◯◯◯◯◯◯タイプ'
        },
        {
          title: '朝食',
          category: '必須',
          data: 'なし'
        },
        {
          title: '夕食',
          category: '必須',
          data: 'なし'
        },
        {
          title: '料金',
          category: '必須',
          data: '0000円'
        },
        {
          title: 'サイトURL',
          category: '必須',
          data: 'https://aaaaa.aaaa.aaa/'
        }
      ],
      orderDetailF: {
        stayDay: '0000年00月00日から',
        nightCnt: '2',
        roomCnt: '3',
        checkInTm: '14',
        stayRoomDetails: [
          {
            memberCount1: 2,
            memberPrice1: 5000,
            memberCount2: 3,
            memberPrice2: 6000,
            visitorCount1: 1,
            visitorPrice1: 5500
          },
          {
            memberCount1: 2,
            memberPrice1: 6000,
            memberCount2: 3,
            memberPrice2: 7000,
            visitorCount1: 1,
            visitorPrice1: 6500
          }
        ]
      }
    }
  },
  mounted() {
    const bsApp03001 = _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_03_001', null))
    this.useDate = _.get(bsApp03001, 'useDate', '')
    this.nightCnt = _.get(bsApp03001, 'nightCnt', '')
    this.roomCnt = _.get(bsApp03001, 'roomCnt', '')
    this.checkOutTm = _.get(bsApp03001, 'checkOutTm', '')
    this.typeOfRoom = _.get(bsApp03001, 'typeOfRoom', '')
    this.stayRoomDayPrtic = _.get(bsApp03001, 'stayRoomDayPrtic', '')
    this.totalAmount = _.get(bsApp03001, 'totalAmount', '')
    const breakfast = _.get(bsApp03001, 'contentRegister.breakfast', null)
    const dinner = _.get(bsApp03001, 'contentRegister.dinner', null)
    this.totalAdult = _.get(bsApp03001, 'totalAdult', '')
    this.totalChild = _.get(bsApp03001, 'totalChild', '')
    console.log('bsApp03001', bsApp03001)
    this.dataWebRegister = [
      {
        title: 'サイト名',
        category: '必須',
        data: _.get(bsApp03001, 'contentRegister.siteName', null)
      },
      {
        title: 'プラン名',
        category: '必須',
        data: _.get(bsApp03001, 'contentRegister.planName', null)
      },
      {
        title: '部屋タイプ',
        category: '必須',
        data: _.get(bsApp03001, 'contentRegister.typeRoom', null)
      },
      {
        title: '朝食',
        category: '必須',
        data: +breakfast === 0 ? 'あり' : +breakfast === 1 ? 'なし' : ''
      },
      {
        title: '夕食',
        category: '必須',
        data: +dinner === 0 ? 'あり' : +dinner === 1 ? 'なし' : ''
      },
      {
        title: '料金',
        category: '必須',
        data: `${_.get(bsApp03001, 'contentRegister.amount', null)  } 円`
      },
      {
        title: 'サイトURL',
        category: '必須',
        data: _.get(bsApp03001, 'contentRegister.siteUrl', null)
      }
    ]
    this.dataItemOrder = _.get(bsApp03001, 'dataItemOrder', null)
    this.orderDetail = _.get(bsApp03001, 'orderDetail', this.orderDetailF)
    this.contentRegister = _.get(bsApp03001, 'contentRegister', this.data)
  },
  methods: {
    gotoComplete() {
      const bsApp03001 = _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_03_001', null))
      const dataOrder = {
        acptNo: _.get(bsApp03001, 'acptNo', null),
        acptDtlNo: _.get(bsApp03001, 'acptDtlNo', null),
        travelBranchNo: null,
        applyDetails: {
          lowpriceCtgry: 1,
          anotherTravelCompanyName: _.get(bsApp03001, 'contentRegister.siteName', null),
          planName: _.get(bsApp03001, 'contentRegister.planName', null),
          roomType: _.get(bsApp03001, 'contentRegister.typeRoom', null),
          breakfastFlag: _.get(bsApp03001, 'contentRegister.breakfast', null),
          dinnerFlag: _.get(bsApp03001, 'contentRegister.dinner', null),
          stayDay: _.get(bsApp03001, 'stayDay', null),
          anotherTravelCompanyPrice: _.get(bsApp03001, 'contentRegister.amount', null),
          anotherTravelCompanyUrl: _.get(bsApp03001, 'contentRegister.siteUrl', null),
          applyDtlComment: null
        }
      }
      this.$repositories('order').orderLowPrice(dataOrder).then(
        (response) => {
          console.log(response)
          const query = this.$route.query
          this.$router.push({path: '/low-price-complete', query})
        },
        (error) => {
          this.$toasted.error(error?.message)
        })
    },
    handleBack() {
      this.$router.go(-1)
    },
    getVisitorPrice(MemberChrg, BoneSbsidChrg, roomMemberChrg) {
      return MemberChrg ? MemberChrg + BoneSbsidChrg : roomMemberChrg
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
